import Joi from 'joi';
import { passwordRegex } from '../constant/constant';

export const createUserValidator = (payload: unknown) => {
  const obj = Joi.object()
    .keys({
      firstName: Joi.string().required(),
      lastName: Joi.string().required(),
      password: Joi.string().pattern(new RegExp(passwordRegex)),
      userName: Joi.string().alphanum(),
      email: Joi.string().required(),
      gender: Joi.string().required(),
      role: Joi.string().required(),
      dob: Joi.date().optional().allow('').allow(null),
    })
    .required();

  const { error } = obj.validate(payload);

  return error ? error.details : false;
};
